<template>
  <!-- 购物车列表块 -->
  <div class="record-container">
    <div class="meal-view">
      <img :src="record.imgUrl" class="meal-icon" @error="errorLoadImg()" />
      <span class="detail-view">
        <div class="meal-name">{{ record.name }}</div>
        <div class="meal-name">{{ titleText }}</div>
        <div class="price-view">
          <span class="price">¥{{ record.prize }}</span>
          <span class="meal-count-view">
            <span class="minus" @click="changeShopValue('delete')">
              <img
                class="minus-icon"
                src="../../../../static/img/shopping_cart/minus.png"
              />
            </span>
            <span class="count">{{ record.shopValue }}</span>
            <span class="add" @click="changeShopValue('add')">
              <img
                class="add-icon"
                src="../../../../static/img/shopping_cart/add.png"
              />
            </span>
          </span>
        </div>
      </span>
    </div>
    <div class="break-line" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RecordItem",
  props: {
    record: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      shopping_coffee_data: "shopping_coffee_data",
    }),
    titleText() {
      const title = this.record.preferences.join(",");
      return title.length > 12 ? title.slice(0, 12) + "..." : title;
    },
  },
  data() {
    return {
      remarks: "",
    };
  },
  methods: {
    /**
     *咖啡增减数量计算购物车数量
     */
    changeShopValue(type) {
      let newCoffeeList = [];
      //找到匹配的数据下标
      const currentIndex = this.shopping_coffee_data.findIndex(
        (x) => x.id === this.record.id&& x.preferences.join() === this.record.preferences.join()
      );
      if (currentIndex < 0) {
        return false;
      } else {
        // 更新咖啡购物车列表
        if (type === "add") {
          newCoffeeList = [
            ...this.shopping_coffee_data.slice(0, currentIndex),
            {
              ...this.shopping_coffee_data[currentIndex],
              shopValue: this.shopping_coffee_data[currentIndex].shopValue + 1,
            },
            ...this.shopping_coffee_data.slice(currentIndex + 1),
          ];
        } else {
          // 判定当前咖啡数量变0的话显示移除购物车弹窗
          if (type === "delete" && this.record.shopValue === 1) {
            // 将该数据删除 过滤掉该数据 重新更新咖啡购物车数据
            newCoffeeList = this.shopping_coffee_data.filter(
              (x) => !(x.id === this.record.id&& x.preferences.join() === this.record.preferences.join())
            );
          } else {
            newCoffeeList = [
              ...this.shopping_coffee_data.slice(0, currentIndex),
              {
                ...this.shopping_coffee_data[currentIndex],
                shopValue:
                  this.shopping_coffee_data[currentIndex].shopValue - 1,
              },
              ...this.shopping_coffee_data.slice(currentIndex + 1),
            ];
          }
        }
      }
      this.$store.commit("updataCoffeeShop", newCoffeeList);
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg() {
      const eventTag = event.toElement || event.target;
      eventTag.src =
        "../../../../static/img/shopping_cart/pic_home_default.png";
    },
  },
};
</script>

<style lang="less" scoped>
.record-container {
  width: 280px;
  .meal-view {
    width: 100%;
    height: 70px;
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    .meal-icon {
      width: 60px;
      height: 100%;
      border-radius: 4px;
    }
    .detail-view {
      width: 210px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 8px;
      .meal-name {
        font-size: 16px;
        color: #333333;
      }
      .price-view {
        display: flex;
        justify-content: space-between;
        .price {
          font-size: 18px;
          color: #ff4c4c;
        }
        .meal-count-view {
          display: flex;
          justify-content: flex-end;
          height: 24px;
          text-align: center;
          cursor: pointer;
          .minus {
            border-radius: 4px 0px 0px 4px;
            border: solid 1px #e0e0e0;
            .minus-icon {
              width: 12px;
              height: 12px;
            }
          }
          .count {
            width: 36px;
            display: inline-block;
            border-left: 0;
            border-right: 0;
            color: #333333;
            font-size: 16px;
            border: solid 1px #e0e0e0;
          }
          .add {
            border-radius: 0px 4px 4px 0px;
            border: solid 1px #e0e0e0;
            .add-icon {
              width: 12px;
              height: 12px;
            }
          }
          .minus,
          .add {
            width: 30px;
            display: inline-block;
            color: #999999;
          }
        }
      }
    }
  }
  .break-line {
    border-bottom: 1px solid #e0e0e0;
    margin-top: 15px;
  }
  .break-block {
    width: 300px;
    height: 6px;
    margin-top: 8px;
    margin-left: -10px;
    background-color: #fafafa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/components/CofeeShopItem.vue